const styles = theme => ({
  divider: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '24px',
    width: '256px',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  button: {
    minWidth: '16px !important',
    height: '16px !important',
    padding: '0px !important',
    margin: '0 8px !important',
    borderRadius: '16px',
    backgroundColor: '#5DADFF !important',
    transition: 'all 0.5s ease',
    '&:hover': {
      width: 'auto !important',
      minWidth: '20px !important',
      padding: '0 4px !important',
    },
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    marginBottom: '2px',
    fontSize: '10px',
    color: '#ffffff',
    marginLeft: '0',
    maxWidth: '0',
    opacity: '0',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    transition: 'all 0.5s ease',
    '$button:hover &': {
      marginLeft: '4px',
      maxWidth: '100px',
      opacity: '1',
    },
  },
  icon: {
    fontSize: '12px !important',
    color: '#ffffff',
  },
  dividerLine: {
    flexGrow: 1,
  },
})

export default styles
